const { getIconPath } = require('bench-style-constants');

/**
 * The bl-svg-icon component renders SVG icons based on path constants.
 */

class SvgIconController {
  iconPath(icon) {
    return getIconPath(icon);
  }
  getIconSize(size = 'medium') {
    switch (size) {
      case 'small':
        return {
          width: '16px',
          height: '16px',
        };
      case 'large':
        return {
          width: '32px',
          height: '32px',
        };
      case 'medium':
      default:
        return {
          width: '24px',
          height: '24px',
        };
    }
  }
}

module.exports = angular.module('bench.ui.svgIcon', []).component('blSvgIcon', {
  bindings: {
    icon: '@',
    size: '@',
  },
  controller: SvgIconController,
  controllerAs: 'vm',
  template: `
      <svg
        class="svgIcon"
        ng-style="vm.getIconSize(vm.size)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path ng-attr-d="{{vm.iconPath(vm.icon)}}" />
      </svg>
    `,
});
